import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCondaForgeComponent } from './simple-icons-conda-forge.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCondaForgeComponent ],
    exports:      [ SimpleIconsCondaForgeComponent ],
    bootstrap:    []
})
export class SimpleIconsCondaForgeModule {}
